import { LocalizationTreeMap } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { de_DE } from "./de_DE";

export const DEFAULT_TRANSLATIONS: LocalizationTreeMap = {
	de: de_DE,
	de_DE
};
